<template>
  <div>
    <eden-page-stats
      class="mt-0"
      :title="'Overview'"
      :loading="loading"
      :stats="stats"
      :show-periods="true"
      :periods="periods"
      :show-custom-period="true"
      @set-period="getScheduleStats"
    />
    <schedule-view
      :loading="loading"
      :service="'meal'"
      :period="period"
      :schedule="schedule"
      @set-period="getSchedule"
    />
  </div>
</template>

<script>
import { mealSchedule } from "./Views/mock";
import ScheduleView from "@/components/Logistics/Schedule/Views/ScheduleView";

export default {
  name: "ScheduleMeal",
  components: { ScheduleView },
  data() {
    return {
      loading: false,
      period: "today",
      periods: {
        today: "Today",
        tomorrow: "Tomorrow",
        thisweek: "This week",
      },
      schedule: mealSchedule(),
    };
  },
  computed: {
    title() {
      return `${this.schedule.length}  Deliveries Today`;
    },
    stats() {
      const stats = [
        {
          label: "Food deliveries",
          figure: 145,
        },
        {
          label: "Riders assigned",
          figure: 52,
        },
        {
          label: "Riders completed",
          figure: 50,
        },
        {
          label: "Riders pending",
          figure: 50,
        },
        {
          label: "Complete deliveries",
          figure: 74,
        },
        {
          label: "Incomplete deliveries",
          figure: 71,
        },
      ];

      return this.period !== "today" ? stats.slice(0, 2) : stats;
    },
  },
  methods: {
    getScheduleStats({ period, from, to }) {
      this.period = period;
      console.log(period, from, to);
    },
    getSchedule({ period, from, to }) {
      console.log(period, from, to);
    },
  },
};
</script>
